import React, { HTMLAttributes } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.marginBase * 2,
  },
}));

export const SubmitButtonsLine = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)} {...props} />
  );
};
